import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

// Generic internal link button (pill). Used for on-site CTAs.
export const LinkButton = ({
  to,
  children,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  icon = true,
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-legacy-mint focus-visible:ring-offset-2 focus-visible:ring-offset-legacy-charcoal";
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm md:text-base",
    lg: "px-9 py-4 text-base",
  };
  const variants = {
    primary: "bg-legacy-mint text-legacy-charcoal hover:bg-legacy-mint/90",
    outline:
      "bg-transparent border border-white/40 text-white hover:border-legacy-mint hover:text-legacy-mint",
    outlineDark:
      "bg-transparent border border-legacy-charcoal/30 text-legacy-charcoal hover:border-legacy-gold hover:text-legacy-gold",
    gold: "bg-legacy-gold text-white hover:bg-legacy-gold/90",
  };
  return (
    <motion.span whileTap={{ scale: 0.97 }} className="inline-flex">
      <Link
        to={to}
        className={cn(base, sizes[size], variants[variant], className)}
        data-testid={testId}
      >
        {children}
        {icon && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
      </Link>
    </motion.span>
  );
};
